import { render } from "./LogsList.vue?vue&type=template&id=20a451d8"
import script from "./LogsList.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/LogsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20a451d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20a451d8', __exports__)) {
    api.reload('20a451d8', __exports__)
  }
  
  module.hot.accept("./LogsList.vue?vue&type=template&id=20a451d8", () => {
    api.rerender('20a451d8', render)
  })

}


export default __exports__